<template>
  <base-container :fluid="true" class="broadcast-planning">
    <base-container>
      <planning-selector
        v-if="campaigns"
        :plannings="campaigns"
        @pharmacyChanged="selectPlanning"
        @campaignChanged="handleCampaignChange"
      />
      <!-- <the-header>
        <template v-slot:leftAligned>
          <h1 class="lvl1-heading">
            Planning
            <span>de diffusion</span>
          </h1>
          <span>
            Organisez vos campagnes de communication à la pharmacie en avance en
            sélectionnant les vidéos à mettre dans votre planning mensuel.
          </span>
        </template>
        <template v-slot:rightAligned>
          <base-button
            @click.native="goToplanningHistory"
            :fluid="true"
            type="hollowed"
            >HISTORIQUE DES PLANNINGS</base-button
          >
        </template>
      </the-header> -->
    </base-container>
    <base-container>
      <template v-if="selectedPlanning">
        <SingleMonthPlanning
          ref="singlemonth"
          :planning="selectedPlanning"
          :video="video"
        />
        <!-- <SingleMonthPlanning
          v-for="planning in plannings"
          :key="planning.key"
          :planning="planning"
          @refreshPlanning="getPlannings"
        /> -->
      </template>
    </base-container>
  </base-container>
</template>

<script>
// import TheHeader from "@/components/TheHeader"
import SingleMonthPlanning from "./components/SingleMonthPlanning"
// import { fetchPlannings } from "@/api/plannings"
import {
  getCampaignsAnnonceur,
  getCampaignPharmacistInfos
} from "@/api/campaigns"
import { fetchVideo } from "@/api/videos"
import { loaderMixin, planningMixin } from "@/mixins"
import PlanningSelector from "./components/PlanningSelector"

export default {
  components: {
    // TheHeader,
    SingleMonthPlanning,
    PlanningSelector
  },
  data() {
    return {
      params: {
        campaign_id: null,
        pharmacy_id: null
      },
      plannings: null,
      selectedPlanning: null,
      video: null,
      campaigns: null,
      pharmacies: null,
      pharmacistPlannings: null,
      selectedCampaign: null,
      campaignVideoId: null
    }
  },
  mixins: [loaderMixin, planningMixin],
  methods: {
    goToplanningHistory() {
      this.$router.push({ name: "planningHistory" })
    },
    // getPlannings() {
    //   fetchPlannings()
    //     .then(this.structurePlanningsData)
    //     .then(plannings => {
    //       this.plannings = plannings
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    handleCampaignChange(campaignInfos) {
      //console.log(campaignInfos)
      this.selectedPlanning = null
      this.params.campaign_id = campaignInfos.id
      this.campaignVideoId = campaignInfos.video_id
      this.getCampaignVideo(this.campaignVideoId)
      //this.getCampaign(this.value.id)
    },
    async selectPlanning(planning) {
      this.params.pharmacy_id = planning.id
      const { data } = await this.getCampaignPharmacistInfo()
      this.selectedPlanning = data
      if (this.$refs.singlemonth) {
        this.$refs.singlemonth.$refs.singlemonthtab.resetTab()
      }
      // this.$refs.singlemonth.resetTab()
    },
    async getCampaignPharmacistInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          const infos = await getCampaignPharmacistInfos(
            this.params.campaign_id,
            this.params
          )
          this.pharmacistPlannings = infos.data
          resolve(infos)
        } catch (err) {
          console.error(err)
          reject(err)
        }
      })
    },
    getCampaignsOfAnnonceur() {
      const userId = this.$store.state.user.info.id
      getCampaignsAnnonceur(userId)
        .then(campaigns => {
          this.campaigns = campaigns.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getCampaignVideo() {
      fetchVideo(this.campaignVideoId)
        .then(video => {
          //console.log(video)
          this.video = video
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  mounted() {
    // this.getPlannings()
    this.getCampaignsOfAnnonceur()
    //this.getCampaignPharmaciesSupports()
  }
}
</script>

<style scoped></style>
